export const GET_MY_DATASETS = "GET_MY_DATASETS";
export const SELECT_DATASET = "SELECT_DATASET";

export const OPEN_LEFT_PANEL = "OPEN_LEFT_PANEL";

export const CONNECTOR = "CONNECTOR";
export const DECOMPOSER = "DECOMPOSER";
export const GEOMETRY_TRANSFORMER = "GEOMETRY_TRANSFORMER";
export const GEOMETRY_EDITOR = "GEOMETRY_EDITOR";
export const NORMALISER = "NORMALISER";
export const PUBLISHER = "PUBLISHER";
export const IMPORT_DATASET = "IMPORT_DATASET";
export const MASS_UPDATE = "MASS_UPDATE";
export const TUNE_METADATA = "TUNE_METADATA";
export const DATASET_TABLE = "DATASET_TABLE";

export const MY_TARIF = "MY_TARIF";

export const SET_USER = "SET_USER";
export const SET_METRIC = "SET_METRIC";

export const SET_UPD_TABLE_MODAL = "SET_UPD_TABLE_MODAL";